import {useNavigate} from "react-router-dom";
import {useDialog} from "base/dialog/hooks";
import {useErrors} from "base/error/provider";

import {EntityManageDialog} from "base/entity/components/container";
import {PermitExtensionService} from "permitextension/service";
import {
    PermitExtensionForm,
    PermitExtensionInitialFormFields,
} from "permitextension/presentational/form";
import {permit_extension_view_adapter} from "permitextension/model";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import {isOpenExtension, PERMIT_EXTENSION_STATUS} from "permitextension/data";

const usePermitExtensionCreate = permit => {
    const {isDialogOpen, openDialog, closeDialog} = useDialog();
    const {handleErrors} = useErrors();
    const navigate = useNavigate();

    const handleFormSubmit = data => {
        return PermitExtensionService.create(permit_extension_view_adapter({...data}))
            .then(element => {
                closeDialog();
                navigate(
                    `/permits/extensions/list/${element.id}/application/pendente_guias_e_datas`
                );
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const hasOpenExtensions = () => {
        return permit?.extension_set?.some(extension =>
            isOpenExtension(extension.status)
        );
    };

    const isExtendButtonDisabled = () => {
        return permit?.is_valid || hasOpenExtensions();
    };

    const extendButton = (
        <Box display="flex" justifyContent="flex-end">
            <Button
                variant="contained"
                color="secondary"
                endIcon={<MoreTimeIcon />}
                onClick={openDialog}
                disabled={isExtendButtonDisabled()}
            >
                Prorrogar
            </Button>
        </Box>
    );

    const extendDialog = (
        <EntityManageDialog
            dialogTitle="Prorrogar autorização"
            dialogContent={
                <PermitExtensionForm
                    permitId={permit?.id}
                    onSubmit={handleFormSubmit}
                    onCancel={closeDialog}
                >
                    <PermitExtensionInitialFormFields minDate={permit?.on_date} />
                </PermitExtensionForm>
            }
            isDialogOpen={isDialogOpen}
        />
    );

    return {
        extendButton,
        extendDialog,
    };
};

export {usePermitExtensionCreate};
